import { Entity } from "../../Entity";
import ActivityTemplateFactory from "../../Factories/ActivityTemplateFactory";
import { FactoryInterface } from "../../FactoryInterface";
import { ActivityTemplateInterface } from "./ActivityTemplateInterface";
import { TaskTemplateInterface } from "../Task/TaskTemplateInterface";

class ActivityTemplate extends Entity implements ActivityTemplateInterface {

  constructor(public data) {
    super();
  }

  public getFactory(): FactoryInterface {
    return ActivityTemplateFactory;
  }

  get id(): number {
    return this.data.id;
  }

  get name(): string {
    return this.data.name;
  }

  get removed(): boolean {
    return this.data.removed;
  }

  get taskTemplates(): TaskTemplateInterface[] {
    return this.relations("app.taskTemplates", "app.taskTemplatesInActivityTemplates", this.data.id)
    .filter((taskTemplate: TaskTemplateInterface) => taskTemplate.removed === false);
  }
}

export { ActivityTemplate };
